<div class="agpr-financialTimesAttribution">
    <div class="agpr-financialTimesAttribution-logo">
        <img
            [src]="appBaseHref + 'assets/images/ft-logo.svg'"
            height="20"
            width="20"
            alt="Financial Times Logo"
        />
    </div>
    <div class="agpr-financialTimesAttribution-attribution" [innerHTML]="mention.attribution"></div>
</div>
